import { Badge } from '@/app/components/ui/badge'
import { HybridTooltip, HybridTooltipTrigger, TouchProvider, HybridTooltipContent } from '@/app/components/ui/hybrid-tooltip'
import Link from 'next/link'
import React from 'react'

const HybridAuctionBadge = () => {
    return (
        <TouchProvider>
            <HybridTooltip delayDuration={150}>
                <HybridTooltipTrigger asChild>
                    <span>
                        <Badge variant="outline" className="cursor-help border-slate-900 border">
                            Hybrid 
                        </Badge>
                    </span>
                </HybridTooltipTrigger>
                <HybridTooltipContent side="bottom" align="end" className="max-w-xs py-3">
                    <div className="space-y-1">
                        <p className="text-xs font-medium">Hybrid Auction</p>
                        <p className="text-xs opacity-90">
                            Bid online or on-site. Online bids are synchronized with floor bids during the live close.
                        </p>
                        <Link href="/hybrid-auction" className="text-xs underline">
                            Learn more
                        </Link>
                    </div>
                </HybridTooltipContent>
            </HybridTooltip>
        </TouchProvider>
    )
}

export default HybridAuctionBadge